import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowNumber } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AiSearchToolCallViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  sequenceValue?: { displayId: string; id: string } | null;
  sequence: number;
  toolNameValue?: { displayId: string; id: string } | null;
  toolName: string;
  patternValue?: { displayId: string; id: string } | null;
  pattern: string;
  navigationPathValue?: { displayId: string; id: string } | null;
  navigationPath: string;
  toolArgumentsValue?: { displayId: string; id: string } | null;
  toolArguments: string;
  resultValue?: { displayId: string; id: string } | null;
  result: string;
  durationMsValue?: { displayId: string; id: string } | null;
  durationMs: number;
  successValue?: { displayId: string; id: string } | null;
  success: boolean;
  errorMessageValue?: { displayId: string; id: string } | null;
  errorMessage: string;
};

export const AiSearchToolCallViewForm: React.FC<AiSearchToolCallViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      sequence = 0,
      toolName = "",
      pattern = "",
      navigationPath = "",
      toolArguments = "{}",
      result = "{}",
      durationMs = 0,
      success = false,
      errorMessage = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAiSearchToolCallLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowNumber
                  value={sequence}
                  label={langStore.AiSearchToolCallSequenceLabel}
                />
                <ShowMultiLine
                  value={toolName}
                  label={langStore.AiSearchToolCallToolNameLabel}
                />
                <ShowMultiLine
                  value={pattern}
                  label={langStore.AiSearchToolCallPatternLabel}
                />
                <ShowMultiLine
                  value={navigationPath}
                  label={langStore.AiSearchToolCallNavigationPathLabel}
                />
                <InputCodeEditor
                  value={toolArguments}
                  onChange={() => {}}
                  label={langStore.AiSearchToolCallToolArgumentsLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={result}
                  onChange={() => {}}
                  label={langStore.AiSearchToolCallResultLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowNumber
                  value={durationMs}
                  label={langStore.AiSearchToolCallDurationMsLabel}
                />
                <ShowBoolean
                  value={success}
                  label={langStore.AiSearchToolCallSuccessLabel}
                />
                <ShowMultiLine
                  value={errorMessage}
                  label={langStore.AiSearchToolCallErrorMessageLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
